import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @font-face {
      font-family: 'roboto';
      src: url('/static/fonts/roboto-condensed.ttf');
  }
  @font-face {
    font-family: 'i-missed-you';
    src: url('/static/fonts/imissedyou.ttf');
  }

  h3, p, a {
      font-family: 'roboto';
  }

  #outter {
    display: flex;
    flex-direction: column;
    position: relative;
    background-image: url('/static/img/back-cover.jpg');
    background-size: cover;
    background-position: center;
    min-height: 100vh;

    :before {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background: linear-gradient(0deg, transparent, white, white);
    }
    > div {
      flex: 1 auto;
    }
    footer {
      z-index: 1;
      flex: 1 auto;
      display: flex;
      justify-content: center;
      align-items: flex-end;

      p {
        color: white;
        text-align: center;
        width: 100%;
        background-color: darkslateblue;
        padding: 5px 10px;
        margin: 0;

        a {
          cursor: pointer;
          color: white;
          text-decoration: none;

          :hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
  #master-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 40px;
  }
  #header {
    text-align: center;
    margin: 0 auto;
    width: 100%;

    img {
      width: 100px;
      max-width: 100%;
    }
    h1 {
      font-family: 'roboto';
      color: orange;
    }
    h3 {
      font-family: 'i-missed-you';
      font-size: 26px;
      margin: 0;
    }
    #points-section {
      position: absolute;
      top: 60px;
      font-family: 'roboto';
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 80px;
      width: 80px;
      border-radius: 64px;
      background-color: #eee;
    }
  }
`;
